import { js_utils } from "../utils/frfr-js-utils";
import { protobomp_utils_entity_create_assembly, protobomp_utils_entity_create_primitive, protobomp_utils_entity_create_progressive_assembly } from "../utils/frfr-protobomp-utils";
import tclocal from "./ter-consts-local-lib";


//
export const terProtobompUtils_make_protobomp_manifest_terkk_v0_1 = (terkk_protobompclass, options) => {
  //
  const protobomp_manifest = {
    "protobompclass": "terkk",
    "version": "0.1",
    "terkk_protobompclass": terkk_protobompclass,
    "readme": "",
    "options": options,
  };
  /*
  if (options && (options.allow_root_btns === true || options.allow_root_btns === false)) {
    protobomp_manifest.options.allow_root_btns = options.allow_root_btns;
  }
  */
  return protobomp_manifest;
};
//
export const terProtobompUtils_make_protobomp_manifest_terkk_latest = (terkk_protobompclass, options) => {
  return terProtobompUtils_make_protobomp_manifest_terkk_v0_1(terkk_protobompclass, options);
};


//
export const terProtbompUtils_extract_terkk_protobompclass_from_protobomp = (protobomp) => {
  let terkk_protobompclass;
  if (protobomp && protobomp.manifest && protobomp.manifest.terkk_protobompclass) {
    terkk_protobompclass = protobomp.manifest.terkk_protobompclass;
  }
  return terkk_protobompclass;
};


// ---------- ter protobomp pbnode entities


//
export const terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP = (formState, options = {}, customkey = null) => {
  const new_entity = protobomp_utils_entity_create_assembly(options);
  new_entity.pbnode_class = tclocal.ASSEMBLY_TER_SKLOP;
  if (typeof customkey === 'string') {
    new_entity.customkey = customkey;
  }
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    kolicina: 0,
    jm: 'kom',
    "operacija1": "OPSKL", // SKLOP default operaicje skalpanje, a radni centar finalcizacija.
    "rc1": "GRCFIN", //
    ..._state2
  };
  delete new_entity.state.tempkey; // just in case
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL = (formState) => {
  const new_entity = protobomp_utils_entity_create_primitive();
  new_entity.pbnode_class = tclocal.PRIMITIVE_TER_MATERIJAL;
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    terkategorija: null,
    tergrupacustom: null,
    identcustom: '',
    // naziv: '',
    // naziv_materijala: '',
    naziv_materijala: null,
    kolicina: 0,
    jm: null,
    Par28: null,
    Par29: null,
    ..._state2
  };
  delete new_entity.state.tempkey;
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL = (formState) => {
  const new_entity = protobomp_utils_entity_create_primitive();
  new_entity.pbnode_class = tclocal.PRIMITIVE_TER_PROFIL;
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    duzina: -1, // kolicina za meterijal
    leviger: 90,
    desniger: 90,
    desniger: 90,
    kolicina: 0,
    jm: 'kom',
    "operacija1": "OPSEC",
    "rc1": "",
    // TODO materijal ident za operaciju
    ..._state2
  };
  delete new_entity.state.tempkey;
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM = (formState) => {
  const new_entity = protobomp_utils_entity_create_primitive();
  new_entity.pbnode_class = tclocal.PRIMITIVE_TER_LIM;
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    // sirina: 0,
    dimenzija1: null,
    dimenzija2: null,
    razvijenamera1: null,
    razvijenamera2: null,
    povrsina: 0,
    cnccrtez: null,
    "operacija1": "OPSEC",
    "operacija2": null,
    "rc1": "RCPRBS4",
    "rc2": null,
    kolicina: 0,
    jm: 'kom',
    // TODO materijal ident za operaciju
    ..._state2
  };
  delete new_entity.state.tempkey;
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_KAMENAVUNA = (formState) => {
  const new_entity = protobomp_utils_entity_create_primitive();
  new_entity.pbnode_class = tclocal.PRIMITIVE_TER_KAMENAVUNA;
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    // sirina: 0,
    duzina: 0,
    visina: 0,
    povrsina: 0,
    // cnccrtez: null,
    "operacija1": "OPSEC",
    "rc1": "RCHOL",
    kolicina: 0,
    jm: 'm2',
    // TODO materijal ident za operaciju
    ..._state2
  };
  delete new_entity.state.tempkey;
  return new_entity;
};


// ----- SKETCH


//
export const terProtobompUtils_pbnode_entity_create_ASSEMBLY_SKETCH_V1 = (formState, options = {}, customkey = null) => {
  const new_entity = protobomp_utils_entity_create_assembly(options);
  new_entity.pbnode_class = tclocal.ASSEMBLY_SKETCH_V1;
  if (typeof customkey === 'string') {
    new_entity.customkey = customkey;
  }
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    kolicina: 0,
    jm: '',
    "operacija1": "",
    "operacija2": "",
    "operacija3": "",
    "operacija4": "",
    "operacija5": "",
    note: '',
    ..._state2
  };
  delete new_entity.state.tempkey; // just in case
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PROGRESSIVE_ASSEMBLY_SKETCH_V1 = (formState, options = {}, customkey = null) => {
  const new_entity = protobomp_utils_entity_create_progressive_assembly(options);
  new_entity.pbnode_class = tclocal.PROGRESSIVE_ASSEMBLY_SKETCH_V1;
  if (typeof customkey === 'string') {
    new_entity.customkey = customkey;
  }
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    kolicina: 0,
    jm: '',
    "operacija1": "",
    "operacija2": "",
    "operacija3": "",
    "operacija4": "",
    "operacija5": "",
    note: '',
    ..._state2
  };
  delete new_entity.state.tempkey; // just in case
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PRIMITIVE_SKETCH_DIR_M_V1 = (formState) => {
  const new_entity = protobomp_utils_entity_create_primitive();
  new_entity.pbnode_class = tclocal.PRIMITIVE_SKETCH_DIR_M_V1;
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv_materijala: '',
    utrosak: 0,
    utrosak_jm: '',
    note: '',
    ..._state2
  };
  delete new_entity.state.tempkey;
  return new_entity;
};
//
export const terProtobompUtils_pbnode_entity_create_PRIMITIVE_SKETCH_OPS_V1 = (formState) => {
  const new_entity = protobomp_utils_entity_create_primitive();
  new_entity.pbnode_class = tclocal.PRIMITIVE_SKETCH_OPS_V1;
  let _state2 = {};
  if (js_utils.is_object(formState)) {
    _state2 = formState;
  }
  new_entity.state = {
    naziv: '',
    kolicina: 0,
    jm: '',
    naziv_materijala: '',
    utrosak: 0,
    utrosak_jm: '',
    "operacija1": "",
    "operacija2": "",
    "operacija3": "",
    "operacija4": "",
    "operacija5": "",
    note: '',
    ..._state2
  };
  delete new_entity.state.tempkey;
  return new_entity;
};